import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // 개발 시 콘솔로 명시적 출력
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="glass rounded-3xl p-8">
        <div className="flex items-center gap-3 text-red-600">
          <i className="fa-solid fa-triangle-exclamation text-2xl" aria-hidden="true" />
          <h2 className="font-display text-xl font-bold">화면을 렌더링하지 못했어요</h2>
        </div>
        <p className="mt-3 text-sm text-surface-900/70 dark:text-surface-100/70">
          개발자 콘솔의 자세한 메시지를 확인하세요. 페이지를 다시 시도하려면 아래 버튼을 누르세요.
        </p>
        <pre className="mt-4 text-xs whitespace-pre-wrap rounded-xl border border-surface-200 dark:border-white/10 bg-white/60 dark:bg-white/[0.04] p-3">
          {this.state.error.message}
        </pre>
        <button type="button" onClick={this.reset} className="btn btn-primary mt-4">
          <i className="fa-solid fa-rotate" aria-hidden="true" /> 다시 시도
        </button>
      </div>
    );
  }
}
